import React from 'react';

const WizardTableHeader = (props) => {
	let headerTableData =  props.getTableHeaderData();
	return (
		<thead className="">
		<tr className="premiumSettingsWizard-damageBands-label-wrapper">
			<th style={{width: '47px'}} className="premiumSettingsWizard-damageBands-label-rest"> </th>
			<th style={{width: '141px'}} className="premiumSettingsWizard-damageBands-label-rest"> </th>
			<th colSpan={headerTableData.length - 2} className="premiumSettingsWizard-damageBands-label">{'Damages'}</th>
		</tr>
		<tr className="agents-list-table-head">
			{
				headerTableData.map((header, index) => {
					return <th style={header.width?{minWidth: header.width}:null} className="premiumSettingsWizard-table-header-data" key={index}>{header.label}</th>
				})
			}
		</tr>
		</thead>
	)
};

export default WizardTableHeader;